import styles from "./FederationEventsRow.module.styl";
import { format, parseISO } from "date-fns";
import { ru } from "date-fns/locale";
import { number, shape, string } from "prop-types";
import React from "react";

function getEventLocation(regionEvent) {
    let eventLocation = "-";
    if (regionEvent.location) {
        eventLocation = regionEvent.location;
    } else if (regionEvent.locationShortName && regionEvent.locationAddress) {
        eventLocation = regionEvent.locationShortName + ", " + regionEvent.locationAddress;
    }
    return eventLocation;
}

export default function FederationEventsRow({ regionEvent }) {
    const eventLocation = getEventLocation(regionEvent);

    return (
        <div className={styles.row}>
            <div className={styles.federationEventName}>{regionEvent.federationEventName}</div>
            <div className={styles.eventSportType}>{regionEvent.eventSportType}</div>
            <div className={styles.eventType}>{regionEvent.eventType}</div>
            <div className={styles.eventStatus}>{regionEvent.eventStatus}</div>
            <div className={styles.location}>{eventLocation}</div>
            <div className={styles.eventStartDate}>
                {format(parseISO(regionEvent.eventStartDate), "P", { locale: ru })}
            </div>
            <div className={styles.eventEndDate}>
                {format(parseISO(regionEvent.eventEndDate), "P", { locale: ru })}
            </div>
        </div>
    );
}

FederationEventsRow.propTypes = {
    regionEvent: shape({
        federationEventId: number,
        federationEventName: string,
        eventSportType: string,
        eventType: string,
        eventStatus: string,
        locationAddress: string,
        locationShortName: string,
        location: string,
        eventStartDate: string,
    }),
};
